// pt-BR translations for GetPaid's invoices feature. Full parity with
// invoices.en.ts — native, consumer-grade Portuguese; fiat wording only
// (transferência bancária na entrada, Pix em reais na saída), no crypto.
const invoices: Record<string, string> = {
  'invoices.title': 'Cobranças',
  'invoices.new': 'Nova cobrança',
  'invoices.loading': 'Carregando cobranças...',
  'invoices.error': 'Não foi possível carregar as cobranças.',
  'invoices.empty.title': 'Nenhuma cobrança ainda',
  'invoices.empty.description': 'Envie sua primeira cobrança e comece a receber.',
  'invoices.empty.cta': 'Criar sua primeira cobrança',
  'invoices.column.status': 'Status',
  'invoices.column.amount': 'Valor',
  'invoices.column.buyer': 'Comprador',
  'invoices.column.createdAt': 'Criada em',

  // Formulário de criação
  'invoices.create.title': 'Nova cobrança',
  'invoices.create.subtitle': 'Envie uma cobrança para o seu comprador e acompanhe o pagamento.',
  'invoices.create.section.buyer': 'Comprador',
  'invoices.create.section.buyer.description': 'Para quem esta cobrança será enviada.',
  'invoices.create.section.lineItems': 'Itens',
  'invoices.create.section.lineItems.description':
    'O subtotal é calculado multiplicando a quantidade pelo preço unitário.',
  'invoices.create.section.details': 'Detalhes da cobrança',
  'invoices.create.section.details.description': 'Moeda e uma data de vencimento opcional.',
  'invoices.create.field.buyerEmail': 'E-mail do comprador',
  'invoices.create.field.buyerName': 'Nome do comprador',
  'invoices.create.field.buyerCountry': 'País do comprador (opcional)',
  'invoices.create.field.buyerRef': 'Referência do comprador',
  'invoices.create.field.currency': 'Moeda',
  'invoices.create.field.dueDate': 'Data de vencimento (opcional)',
  'invoices.create.field.incoterm': 'Incoterm',
  'invoices.create.field.incoterm.none': 'Nenhum',
  'invoices.create.field.portOfLoading': 'Porto de embarque',
  'invoices.create.field.exportContractRef': 'Referência do contrato de exportação',
  'invoices.create.field.description': 'Descrição',
  'invoices.create.field.description.placeholder': 'Item ou serviço',
  'invoices.create.field.descriptionAria': 'Descrição do item {index}',
  'invoices.create.field.quantity': 'Quantidade',
  'invoices.create.field.quantityAria': 'Quantidade do item {index}',
  'invoices.create.field.unitPrice': 'Preço unitário',
  'invoices.create.field.unitPriceAria': 'Preço unitário do item {index}',
  'invoices.create.field.subtotal': 'Subtotal',
  'invoices.create.addLineItem': 'Adicionar item',
  'invoices.create.removeLineItemAria': 'Remover item {index}',
  'invoices.create.total': 'Total',
  'invoices.create.exportDetails.toggle': 'Detalhes de exportação (opcional)',
  'invoices.create.minAmount.note':
    'Os compradores pagam por transferência bancária através do nosso parceiro de pagamentos, que exige um mínimo de aproximadamente {min} (ou equivalente). Cobranças menores não podem ser pagas online.',
  'invoices.create.minAmount.below':
    'Abaixo do mínimo de {min} que seu comprador pode pagar por transferência bancária — aumente o total ou esta cobrança não poderá ser paga online.',
  'invoices.create.submit': 'Criar cobrança',
  'invoices.create.submitting': 'Criando...',
  'invoices.create.cancel': 'Cancelar',
  'invoices.create.error.generic': 'Não foi possível criar a cobrança.',
  'invoices.create.error.validation': 'Corrija os campos destacados.',
  'invoices.create.error.conflict': 'Já existe uma cobrança com esta referência.',
  'invoices.create.error.conflict.link': 'Abrir cobrança existente',
  'invoices.create.error.selfSellerNotReady': 'Termine o onboarding para começar a cobrar.',
  'invoices.create.error.selfSellerNotReady.description':
    'Precisamos verificar sua empresa e configurar seu recebimento via Pix antes que você possa enviar cobranças.',
  'invoices.create.error.selfSellerNotReady.cta': 'Terminar onboarding',

  // Página de detalhes
  'invoices.detail.title': 'Cobrança',
  'invoices.detail.loading': 'Carregando cobrança...',
  'invoices.detail.error': 'Não foi possível carregar a cobrança.',
  'invoices.detail.field.buyer': 'Comprador',
  'invoices.detail.field.buyerEmail': 'E-mail do comprador',
  'invoices.detail.field.total': 'Total',
  'invoices.detail.field.createdAt': 'Criada em',
  'invoices.detail.field.dueDate': 'Data de vencimento',
  'invoices.detail.field.cancelReason': 'Motivo do cancelamento',
  'invoices.detail.section.lineItems': 'Itens',
  'invoices.detail.section.timeline': 'Linha do tempo do pagamento',
  'invoices.detail.column.description': 'Descrição',
  'invoices.detail.column.quantity': 'Qtd',
  'invoices.detail.column.unitPrice': 'Preço unitário',
  'invoices.detail.column.subtotal': 'Subtotal',
  'invoices.detail.lineItems.empty': 'Nenhum item.',
  'invoices.detail.timeline.empty': 'Nenhum evento ainda.',
  'invoices.detail.paymentLink.title': 'Link de pagamento',
  'invoices.detail.paymentLink.copyButton': 'Copiar link de pagamento',
  'invoices.detail.paymentLink.copyError': 'Não foi possível copiar o link',
  'invoices.detail.paymentLink.disabledHint':
    'O link de pagamento não é mais válido para esta cobrança.',
  'invoices.detail.actions.title': 'Ações',
  'invoices.detail.actions.cancel': 'Cancelar cobrança',
  'invoices.detail.actions.cancel.disabledHint':
    'Esta cobrança não pode ser cancelada no estado atual.',
  'invoices.detail.action.invite.button': 'Enviar link de pagamento por e-mail',
  'invoices.detail.action.invite.button.resend': 'Reenviar e-mail de convite',
  'invoices.detail.action.invite.disabledHint':
    'O comprador não pode mais ser convidado para esta cobrança.',
  'invoices.detail.action.invite.error': 'Não foi possível convidar o comprador.',
  'invoices.detail.action.invite.dialog.title': 'Enviar e-mail ao comprador?',
  'invoices.detail.action.invite.dialog.title.resend': 'Reenviar o e-mail de convite?',
  'invoices.detail.action.invite.dialog.description':
    'Vamos enviar o link de pagamento para o comprador abaixo para que ele possa pagar esta cobrança.',
  'invoices.detail.action.invite.dialog.description.resend':
    'Vamos enviar outro link de pagamento para o comprador abaixo, caso o e-mail anterior não tenha sido recebido.',
  'invoices.detail.action.invite.dialog.emailLabel': 'E-mail do comprador',
  'invoices.detail.action.invite.dialog.confirm': 'Enviar e-mail',
  'invoices.detail.action.invite.dialog.confirm.resend': 'Reenviar e-mail',
  'invoices.detail.action.invite.dialog.submitting': 'Enviando...',
  'invoices.detail.action.invite.dialog.dismiss': 'Ainda não',
  'invoices.detail.cancel.title': 'Cancelar cobrança?',
  'invoices.detail.cancel.description':
    'Isso interrompe o andamento da cobrança. Conte-nos o motivo.',
  'invoices.detail.cancel.reason': 'Motivo',
  'invoices.detail.cancel.reason.placeholder': 'ex.: comprador solicitou o cancelamento',
  'invoices.detail.cancel.confirm': 'Cancelar cobrança',
  'invoices.detail.cancel.submitting': 'Cancelando...',
  'invoices.detail.cancel.dismiss': 'Manter cobrança',
  'invoices.detail.cancel.error': 'Não foi possível cancelar a cobrança.',
};

export default invoices;
